import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import { GetWxConfig, SendMessage } from '../api/login';
import wx from 'weixin-js-sdk';
import utils from '../common/utils';
import { Toast } from 'vant';
export function getUrlParams(value) {
  if (location.href.indexOf('#') > -1) {
    //hash模式
    var url = decodeURI(window.location.hash.split("?")[1]);
    var object = {};
    var strs = url.split("&");

    for (var i = 0; i < strs.length; i++) {
      object[strs[i].split("=")[0]] = strs[i].split("=")[1];
    }
  } else {
    //history模式
    var url = decodeURI(location.search);
    var object = {};

    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");

      for (var i = 0; i < strs.length; i++) {
        object[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
  }

  return object[value];
}
export function getWxConfig(url) {
  var ua = navigator.userAgent;
  var isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/);

  if (!isIphone) {
    console.log('安卓签名');
    url = url;
  } else {
    console.log('苹果签名');
    url = window.entryUrl ? window.entryUrl : window.location.href.split('#')[0];
  }

  GetWxConfig({
    url: url
  }).then(function (data) {
    if (!data.iserror) {
      wx.config({
        debug: false,
        appId: data.data.corpid,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: ['checkJsApi', 'getLocation', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'scanQRCode', 'getLocalImgData', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData']
      });
    }
  });
} //验证是不是手机号码

export function isPhoneNumber(phoneNum) {
  var reg = /^1[3456789]\d{9}$/;
  var language = utils.getLocal('language');

  if (!reg.test(phoneNum)) {
    if (language == 'cn') {
      Toast('请填写正确的手机号');
    } else if (language == 'en') {
      Toast('Please fill in the correct mobile number');
    }

    return false;
  }

  return true;
} //检查当前机型

export function isopenByPhone() {
  var ua = navigator.userAgent;
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = ua.match(/(Android)\s+([\d.]+)/),
      isMobile = isIphone || isAndroid; //判断

  if (isMobile || isAndroid) {
    return true;
  } else {
    return false;
  }
} //复制

export function copy(elementId) {
  var aux = document.createElement("input");
  aux.setAttribute("value", document.getElementById(elementId).innerHTML);
  document.body.appendChild(aux);
  aux.select();
  var content = window.getSelection().toString();
  var res = document.execCommand("copy");
  document.body.removeChild(aux);
  return res;
}